import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '@nuso/common/util-errors';
import { PlatformService } from '@nuso/services/types';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlatformServiceStore {
  private notificationService = inject(NotificationService);
  private router = inject(Router);

  private _currentService$ = new BehaviorSubject<PlatformService | null>(null);

  hasCurrentPlatformService(): boolean {
    return this._currentService$.value !== null;
  }

  get currentPlatformService(): PlatformService {
    if (!this._currentService$.value) {
      this.notificationService.addError('Unexpected error: no current platform service in route.');
      throw new Error('Calling currentPlatformService and none is set. Likely using outside of the /s/:id routes.');
    }

    return this._currentService$.value;
  }

  get currentPlatformService$(): Observable<PlatformService | null> {
    return this._currentService$.asObservable();
  }

  // NOTE: we are doing this here instead of a guard because it is possible for the
  // service status to change while on the page, and we want to redirect immediately
  monitorServiceNeedingAuthorization({ queryParams }: { queryParams?: any }) {
    // We need to keep track of if we are already redirecting to avoid infinite loops
    // since we are hitting a different route which is causing the higher up resolver
    // to set this variable again. We could maybe do some sort of distinctUntilChanged
    // on a combo of the service id and the status perhaps, but this does the trick.
    let redirecting = false;
    return this.currentPlatformService$.pipe(
      tap((service) => {
        if (service?.status === 'setup_required') {
          if (!redirecting) {
            console.log('service needing authorization', service, { redirecting });
            this.router.navigate([service.rootPath, 'oauth', 'auth-required'], { queryParams });
            redirecting = true;
          }
        }
      })
    );
  }

  setCurrentPlatformService(service: PlatformService | null) {
    this._currentService$.next(service);
  }
}
